
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dont-sell",
      function () {
        return require("private-next-pages/dont-sell.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dont-sell"])
      });
    }
  